<section class="cmn-innerpage-wrapper roles-management">
  <div class="common-noimage-tab-wrapper">
    <mat-tab-group animationDuration="0ms">
      <!-- Mat Tab One -->
      <mat-tab>
        <ng-template mat-tab-label>
          <h2 class="leave-tab-title">Permissions</h2>
        </ng-template>
        <div class="client-cmn-inner-content-wrapper">
          <div class="inner-content">
            <!-- <div class="permission-group" *ngFor="let module of assignedModule">
              <h2>{{ module?.description }}</h2>

              <div class="permission-box">
                <h3>{{ module?.moduleName }}</h3>
                <label class="switch">
                  <input
                    type="checkbox"
                    [checked]="permissionsState[module?.moduleId]?.isToggleOn"
                    (change)="toggleAllPermissions($event, module?.moduleId)"
                  />
                  <span class="slider round"></span>
                </label>
                <div class="check-roles-inner-wrapper">
                  <button
                    (click)="toggleDropdown($event, module?.moduleId)"
                    class="permission-view-btn"
                  >
                    <span
                      *ngIf="
                        moduleDisplayNames[module?.moduleId]?.length as len;
                        else noSel
                      "
                    >
                      <span
                        *ngFor="
                          let name of moduleDisplayNames[module?.moduleId];
                          let i = index
                        "
                      >
                        {{ name }}<span *ngIf="i < len - 1">, </span>
                      </span>
                    </span>

                    <ng-template #noSel>Select permission</ng-template>
                  </button>
                  <div
                    [ngClass]="{ show: mainDropdownState[module?.moduleId] }"
                    class="roles-checkpopup filter-position"
                    #dropdown
                  >
                    <button
                      class="close-dropdown"
                      (click)="toggleDropdown($event, module?.moduleId)"
                    ></button>
                    <div class="filter-inner-content">
                      <h2>Permissions</h2>
                      <div class="check-wrapper">
                        <div
                          class="check-box"
                          *ngFor="let permission of permissions"
                        >
                          <label class="checkbox-wrapper">
                            <input
                              type="checkbox"
                              [checked]="permission.checked"
                              (change)="
                                togglePermission(
                                  module?.moduleId,
                                  permission.permissionId,
                                  $event
                                )
                              "
                            />
                            {{ permission?.displayName }}
                            <span class="checkmark"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="permission-group" *ngFor="let group of groupedModules | keyvalue">
              <h2>{{ group.key }}</h2>
            
              <div class="permission-box" *ngFor="let module of group.value">
                <h3>{{ module?.moduleName }}</h3>
                <label class="switch">
                  <input
                    type="checkbox"
                    [checked]="permissionsState[module?.moduleId]?.isToggleOn"
                    (change)="toggleAllPermissions($event, module?.moduleId)"
                  />
                  <span class="slider round"></span>
                </label>
            
                <div class="check-roles-inner-wrapper">
                  <button
                    (click)="toggleDropdown($event, module?.moduleId)"
                    class="permission-view-btn"
                  >
                    <span
                      *ngIf="moduleDisplayNames[module?.moduleId]?.length as len; else noSel"
                    >
                      <span
                        *ngFor="let name of moduleDisplayNames[module?.moduleId]; let i = index"
                      >
                        {{ name }}<span *ngIf="i < len - 1">, </span>
                      </span>
                    </span>
                    <ng-template #noSel>Select permission</ng-template>
                  </button>
            
                  <div
                    [ngClass]="{ show: mainDropdownState[module?.moduleId] }"
                    class="roles-checkpopup filter-position"
                    #dropdown
                  >
                    <button
                      class="close-dropdown"
                      (click)="toggleDropdown($event, module?.moduleId)"
                    ></button>
            
                    <div class="filter-inner-content">
                      <h2>Permissions</h2>
                      <div class="check-wrapper">
                        <div
                          class="check-box"
                          *ngFor="let permission of permissions"
                        >
                          <label class="checkbox-wrapper">
                            <input
                              type="checkbox"
                              [checked]="permission.checked"
                              (change)="
                                togglePermission(
                                  module?.moduleId,
                                  permission.permissionId,
                                  $event
                                )
                              "
                            />
                            {{ permission?.displayName }}
                            <span class="checkmark"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
        <div class="full_button_wrapper">
          <button class="cmn-apply-btn" (click)="onApply()">Apply</button>
        </div>
      </mat-tab>
      <!-- Mat Tab Two -->
      <mat-tab>
        <ng-template mat-tab-label>
          <h2 class="leave-tab-title">Members</h2>
        </ng-template>
        <div class="inner-tab-content-wrapper">
          <div class="banking-table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Employee</th>
                  <th>Email</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let member of members">
                  <td>{{ member?.firstName }} {{ member?.lastName }}</td>
                  <td>{{ member?.email }}</td>
                  <td>
                    <div
                      *ngIf="member?.status === 1"
                      (click)="confirmActiveOrDeactivate(member?.id, 0)"
                      style="cursor: pointer"
                    >
                      <img
                        src="assets/images/icons/icon-enable.svg"
                        title="Enable"
                        alt="Enable"
                      />
                    </div>
                    <div
                      *ngIf="member?.status === 0"
                      (click)="confirmActiveOrDeactivate(member?.id, 1)"
                      style="cursor: pointer"
                    >
                      <img
                        src="assets/images/icons/icon-disable.svg"
                        title="Disable"
                        alt="Disable"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</section>
